@if (useHorizontalNav) {
<div class="admin-layout admin-layout--horizontal">
  <header class="admin-topbar" role="banner">
    <div class="admin-topbar__primary">
      <div class="admin-topbar__brand">
        <h1>SIM CHATBOT</h1>
        <p>Gestión de contenidos</p>
      </div>
      @if (menuItems.length > 1) {
      <nav class="admin-topbar__nav" aria-label="Navegación principal">
        @for (item of menuItems; track item.route) {
        <a
          [routerLink]="[item.route]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="nav-link nav-link--horizontal">
          <i [class]="item.iconClass + ' menu-icon'" aria-hidden="true"></i>
          <span class="menu-label">{{ item.label }}</span>
        </a>
        }
      </nav>
      }
      <div class="admin-topbar__actions" [class.has-downloads]="uploadItems().length > 0">
        @if (isLoggedIn()) {
        <span class="user-name" aria-hidden="true">{{ displayName ?? 'Usuario' }}</span>
        <button class="icon-btn" type="button" title="Cerrar sesion" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
        </button>
        @if (uploadItems().length > 0) {
        <button
          type="button"
          class="icon-btn position-relative"
          [class.layout-header__panel-toggle--expanded]="(uploadProgress.panelExpanded$ | async)"
          (click)="uploadProgress.togglePanelExpanded()"
          [attr.aria-expanded]="(uploadProgress.panelExpanded$ | async)"
          [title]="(uploadProgress.panelExpanded$ | async) ? 'Contraer panel de subidas' : 'Expandir panel de subidas'"
          animate.enter="loaded-width-enter"
          animate.leave="loaded-width-leave">
          <i class="bi bi-upload"></i>
          <span
            class="layout-header__panel-badge"
            [class.inprogress]="hasUploadInProgress()"
            [class.incomplete]="hasIncompleteUploads()"
            *ngIf="(uploadProgress.items$ | async)?.length as count">{{ count }}</span>
        </button>
        }
        } @else {
        <button class="icon-btn" type="button" title="Iniciar sesión" (click)="login()">
          <i class="bi bi-box-arrow-in-right"></i>
        </button>
        }
      </div>
    </div>
  </header>

  <div class="admin-main">
    <div class="admin-toolbar">
      <h2>{{ pageTitle }}</h2>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <router-outlet />
      </div>
      @if (uploadItems().length > 0 && uploadProgress.panelExpanded$ | async) {
      <app-upload-progress-panel
        class="uploads-panel"
        [class.uploads-panel--expanded]="uploadProgress.panelExpanded$ | async"
        animate.enter="loaded-width-enter"
        animate.leave="loaded-width-leave" />
      }
    </div>
  </div>
</div>
} @else {
<div class="admin-layout admin-layout--sidebar">
  <div class="sidebar" [class.collapsed]="isSidebarCollapsed">
    <div class="sidebar-header">
      <div class="sidebar-header-top">
        <h1>SIM CHATBOT</h1>
        <button class="toggle-btn" type="button" aria-label="Alternar menu" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
      </div>
      <p>Gestión de contenidos</p>
    </div>

    <nav class="sidebar-nav" aria-label="Navegación principal">
      @for (item of menuItems; track item.route) {
      <div class="nav-item" animate.enter="loaded-height-enter">
        <a
          [routerLink]="[item.route]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="nav-link">
          <i [class]="item.iconClass + ' menu-icon'" aria-hidden="true"></i>
          <span class="menu-label">{{ item.label }}</span>
        </a>
      </div>
      }

      <hr>
    </nav>
  </div>

  <div class="main-wrapper" [class.sidebar-collapsed]="isSidebarCollapsed">
    <div class="header">
      <div class="header-left">
        <button class="toggle-btn" type="button" aria-label="Alternar menu" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
        <h2>{{ pageTitle }}</h2>
      </div>
      <div class="header-actions" [class.has-downloads]="uploadItems().length > 0">
        @if (isLoggedIn()) {
        <span class="user-name" aria-hidden="true">{{ displayName ?? 'Usuario' }}</span>

        <button class="icon-btn" type="button" title="Cerrar sesion" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
        </button>
        @if (uploadItems().length > 0) {
        <button
          type="button"
          class="icon-btn position-relative"
          [class.layout-header__panel-toggle--expanded]="(uploadProgress.panelExpanded$ | async)"
          (click)="uploadProgress.togglePanelExpanded()"
          [attr.aria-expanded]="(uploadProgress.panelExpanded$ | async)"
          [title]="(uploadProgress.panelExpanded$ | async) ? 'Contraer panel de subidas' : 'Expandir panel de subidas'"
          animate.enter="loaded-width-enter"
          animate.leave="loaded-width-leave">
          <i class="bi bi-upload"></i>
          <span
            class="layout-header__panel-badge"
            [class.inprogress]="hasUploadInProgress()"
            [class.incomplete]="hasIncompleteUploads()"
            *ngIf="(uploadProgress.items$ | async)?.length as count">{{ count }}</span>
        </button>
        }
        } @else {
        <button class="icon-btn" type="button" title="Iniciar sesión" (click)="login()">
          <i class="bi bi-box-arrow-in-right"></i>
        </button>
        }
      </div>
    </div>

    <div class="content-wrapper">
      <div class="content">
        <router-outlet />
      </div>

      @if (uploadItems().length > 0 && uploadProgress.panelExpanded$ | async) {
      <app-upload-progress-panel
        class="uploads-panel"
        [class.uploads-panel--expanded]="uploadProgress.panelExpanded$ | async"
        animate.enter="loaded-width-enter"
        animate.leave="loaded-width-leave" />
      }
    </div>
  </div>
</div>
}
